import script from "./FacebookConnectAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./FacebookConnectAlert.vue?vue&type=script&lang=ts&setup=true"

import "./FacebookConnectAlert.vue?vue&type=style&index=0&id=967d62a8&lang=sass"

const __exports__ = script;

export default __exports__